export default {
  fetchList: 'fetch_list'
}
